import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import './AddVenue.css';

const AddVenue = () => {
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      // Create image preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!description || !image) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Information',
        text: 'Please provide both a description and an image.',
        confirmButtonColor: '#5e71f6',
      });
      return;
    }

    const formData = new FormData();
    formData.append('description', description);
    formData.append('image', image);

    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/add-venue`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Venue details added successfully!',
        confirmButtonColor: '#5e71f6',
      });

      // Redirect to the Venue List page
      navigate('/admin/remove-venue');
      
      setDescription('');
      setImage(null);
      setImagePreview(null);
    } catch (error) {
      console.error("Error uploading venue details:", error);
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: 'Failed to add venue details.',
        confirmButtonColor: '#ef4444',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-venue-wrapper">
      <div className="add-venue-container">
        {/* Header Section */}
        <div className="header-section">
          <h1 className="page-title">Add Venue Details</h1>
          <p className="page-subtitle">Upload venue information with description and images</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} encType="multipart/form-data" className="venue-form">
          {/* Description */}
          <div className="form-group">
            <label htmlFor="description" className="form-label">
              Venue Description <span className="required">*</span>
            </label>
            <textarea
              id="description"
              value={description}
              onChange={handleDescriptionChange}
              rows="5"
              required
              placeholder="Enter a detailed description of the venue..."
              className="form-textarea"
            />
          </div>

          {/* Image Upload Card */}
          <div className="file-upload-card">
            <label className="form-label">
              Venue Image <span className="required">*</span>
            </label>
            <div className="file-upload-area">
              <input
                type="file"
                id="image"
                name="image"
                onChange={handleImageChange}
                accept="image/*"
                required
                className="file-input"
              />
              <label htmlFor="image" className="file-upload-label">
                {imagePreview ? (
                  <div className="image-preview-wrapper">
                    <img src={imagePreview} alt="Preview" className="image-preview" />
                    <div className="change-image-text">
                      <svg className="upload-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                      </svg>
                      <span className="upload-text">Click to change image</span>
                    </div>
                  </div>
                ) : (
                  <>
                    <svg className="upload-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                    </svg>
                    <span className="upload-text">Click to upload or drag and drop</span>
                    <span className="upload-hint">PNG, JPG, JPEG (MAX. 10MB)</span>
                  </>
                )}
              </label>
            </div>
          </div>

          {/* Submit Button */}
          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? (
              <>
                <div className="loading-spinner-small"></div>
                Adding Venue...
              </>
            ) : (
              <>
                <svg className="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Add Venue
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddVenue;
